import { render } from "./SelectorShip.vue?vue&type=template&id=605bba24"
import script from "./SelectorShip.vue?vue&type=script&lang=js"
export * from "./SelectorShip.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__